import { render, staticRenderFns } from "./TestResultIcon.vue?vue&type=template&id=20451aaa&scoped=true"
import script from "./TestResultIcon.vue?vue&type=script&lang=ts"
export * from "./TestResultIcon.vue?vue&type=script&lang=ts"
import style0 from "./TestResultIcon.vue?vue&type=style&index=0&id=20451aaa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20451aaa",
  null
  
)

export default component.exports